import { CHAT_SAVE } from './types';

const initialState = {
    selectedOption: 0,
    email: '',
    isSubmitted: false
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case CHAT_SAVE.SAVE_OPTION:
            return {
                ...state,
                selectedOption: action.data.option
            };
        case CHAT_SAVE.SAVE_EMAIL:
            return {
                ...state,
                email: action.data.email
            };
        case CHAT_SAVE.SET_SUBMITTED:
            return {
                ...state,
                isSubmitted: action.data.isSubmitted
            };
        case CHAT_SAVE.RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
